import script from "./tablePopupWorksheet.vue?vue&type=script&setup=true&lang=js"
export * from "./tablePopupWorksheet.vue?vue&type=script&setup=true&lang=js"

import "./tablePopupWorksheet.vue?vue&type=style&index=0&id=12f89e6c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-12f89e6c"]])

export default __exports__